import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initQuantityInputs from '../components/quantityInputs';
import initProductVariants from '../components/product-variants';
import initProductSelectOptions from '../components/product-select-options';
import initRelatedProducts from '../sections/product/related-products';
import initProductStickyAtc from '../components/product-sticky-atc';
import initKlaviyoBis from '../sections/product/klaviyo-bis';
import initProductGalleryLightbox from '../sections/product/gallery-lightbox';
import initDeliveryCountdown from '../sections/product/delivery-countdown';
import initShopTheLook from '../sections/product/shop-the-look';
import initReviewsLink from '../sections/product/reviews-link';

ready(() => {
  initQuantityInputs();
  initProductVariants();
  initProductSelectOptions();
  initRelatedProducts();
  initProductStickyAtc();
  initKlaviyoBis();
  initProductGalleryLightbox();
  initDeliveryCountdown();
  initShopTheLook();
  initReviewsLink();
});

onShopifySectionLoad(() => {
  initRelatedProducts();
  initDeliveryCountdown();
  initShopTheLook();
});
